import { render } from "./AppMobile.layout.vue?vue&type=template&id=c49d36c0"
import script from "./AppMobile.layout.vue?vue&type=script&lang=js"
export * from "./AppMobile.layout.vue?vue&type=script&lang=js"

import "./AppMobile.layout.vue?vue&type=style&index=0&id=c49d36c0&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QLayout});
